import React from 'react'
import classnames from 'classnames';
import { Card } from './Card';
import './PairOfCardsV2.scss'

export function PairOfCardsV2({ className, cards }){
  return (
    <div className={classnames('PairOfCardsV2', className)}>
      {cards.map((card) => (
        <Card card={card} key={`${card.rank}${card.suit}`} className="PairOfCardsV2__card" />
      ))}
    </div>
  )
}
